module.exports = __webpack_public_path__ + "img/not-found.d9553242.png";